<template>
  <div class="home">
    <myUpload></myUpload>
  </div>
</template>

<script>
// @ is an alias to /src
import myUpload from '@/components/myUpload.vue'
export default {
  name: 'HomeView',
  components: {
    myUpload
  }
}
</script>
